import { globalAlertSlice } from './slices/alert.slice'
import { globalSettingsSlice } from './slices/settings.slice'

export const getGlobalReducers = () => ({
  [globalSettingsSlice.name]: globalSettingsSlice.reducer,
  [globalAlertSlice.name]: globalAlertSlice.reducer,
})
